import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { PreloadAllModules, provideRouter, withDebugTracing, withEnabledBlockingInitialNavigation, withPreloading } from '@angular/router';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { lastValueFrom } from 'rxjs';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '@environments/environment';
import { AuthService } from '@modules/auth';
import { ServiceWorkerModule, SwUpdate } from '@angular/service-worker';
import { browserHttpInterceptorProviders } from '@donstudio/ds/interceptors';
import { AppComponent } from './app/app.component';
import { AppRouting } from './app/app-routing';
// #fake-start#
import { FakeAPIService } from '@fake/fake-api.service';
// #fake-end#
// #tokens-start#
import { IS_BROWSER_PLATFORM, LOCATION } from '@donstudio/ds/_tokens';
// #tokens-end#

// app initializer providers get user by token with factory
const getUserByToken = (authService: AuthService) => () => {
  return lastValueFrom(authService.getUserByToken());
}

// app initializer providers theme mode with factory
const themeModeSetup = (isBrowser: boolean) => () => {
  if (isBrowser) {
    const defaultThemeMode = 'system';
    const lsKey = 'ds_theme_mode_value';
    let themeMode = localStorage.getItem(lsKey);
    if (!themeMode) {
      if (defaultThemeMode === 'system') {
        themeMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      } else {
        themeMode = defaultThemeMode;
      }
    }

    document.documentElement.setAttribute('data-bs-theme', themeMode);
  }

  return Promise.resolve('Theme mode setup on page load');
}

// app initializer providers check for update scervice workers with factory
const swCheckForUpdate = (swUpdate: SwUpdate, location: Location) => () => {
  return new Promise(async (resolve, reject) => {
    try {
      if (swUpdate.isEnabled) {
        const isNewVersion = await swUpdate.checkForUpdate();
        if (isNewVersion) {
          const isNewVersionActivated = await swUpdate.activateUpdate();
          if (isNewVersionActivated) location.reload();
          resolve('A new version is available.');
        }
        resolve('Already on the latest version.');
      }
      resolve('Service workers is disabled');
    } catch (error) {
      location.reload();
    }
  });
}


// bootstrapApplication(AppComponent, {
//   providers: [
//     provideRouter(AppRouting,
//       // withPreloading(PreloadAllModules),
//       // withDebugTracing(),
//       withEnabledBlockingInitialNavigation(),
//     ),
//     provideAnimations(),
//     provideHttpClient(
//       withInterceptorsFromDi(),
//       withInterceptors([]),
//     ),
//     importProvidersFrom(BrowserModule.withServerTransition({ appId: 'serverApp' })),
//     importProvidersFrom(TranslateModule.forRoot()),
//     importProvidersFrom(ToastrModule.forRoot()),
//     // #fake-start#
//     importProvidersFrom(environment.isMockEnabled
//       ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
//           passThruUnknownUrl: true,
//           dataEncapsulation: false,
//         })
//       : []
//     ),
//     // #fake-end#
//     importProvidersFrom(ServiceWorkerModule.register('ngsw-worker.js', {
//       enabled: environment.production,
//       // Register the ServiceWorker as soon as the application is stable
//       // or after 30 seconds (whichever comes first).
//       registrationStrategy: 'registerImmediately'
//     })),
//     // #ngrx-start#
//     provideStore({
//       router: routerReducer,
//     }),
//     provideRouterStore(),
//     provideEffects([]),
//     provideStoreDevtools({
//       name: 'Donstudio store',
//       logOnly: environment.production,
//     }),
//     // #ngrx-end#
//     browserHttpInterceptorProviders,
//     {
//       provide: APP_INITIALIZER,
//       useFactory: getUserByToken,
//       multi: true,
//       deps: [AuthService],
//     },
//     {
//       provide: APP_INITIALIZER,
//       useFactory: themeModeSetup,
//       multi: true,
//       deps: [IS_BROWSER_PLATFORM],
//     },
//     {
//       provide: APP_INITIALIZER,
//       useFactory: swCheckForUpdate,
//       multi: true,
//       deps: [SwUpdate, LOCATION],
//     },
//   ]
// });

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(() => {
      if ('serviceWorker' in navigator && environment.production) {
        // navigator.serviceWorker.register('ngsw-worker.js');
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (const registration of registrations) {
            // unregister service worker
            console.log('serviceWorker unregistered');
            registration.unregister();
          }
        });
      }
    })
    .catch((err) => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}

